import { useSearchRouting } from "@/components/Search/SearchResults/hooks/useSearchRouting";

type Props = {
    ignoreQuery: boolean;
};

export const SyncRouteComponent = ({ ignoreQuery }: Props) => {
    useSearchRouting(ignoreQuery);

    return null;
};
